import React from 'react'
import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'
import {Draggable, DraggableProvidedDraggableProps} from 'react-beautiful-dnd'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import {DraggableOverlay} from 'lib/ui/drag-and-drop'
import {useToggle} from 'lib/toggle'
import {Localization} from 'Event/LanguageProvider/translations'
import CountDownTimerConfig from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig'
import {useDuplicateCountDownTimer} from 'Event/Dashboard/components/CountDownTimer/duplicate-countdown-timer'
import {CountDownTimerSettings} from 'Event/Dashboard/components/CountDownTimer'

type EditableCountDownTimerProps = {
  id: string
  countDownTimer: CountDownTimerSettings
  index: number
  keyPath: string
  countDownTimers: Record<string, CountDownTimerSettings>
  localization: Localization | null
  children: React.ReactElement
}

export default function EditableCountDownTimer(
  props: EditableCountDownTimerProps,
) {
  const {flag: configVisible, toggle: toggleConfig} = useToggle()
  const duplicate = useDuplicateCountDownTimer({
    countDownTimers: props.countDownTimers,
    localization: props.localization,
  })

  return (
    <>
      <CountDownTimerConfig
        showing={configVisible}
        onClose={toggleConfig}
        id={props.id}
        keyPath={props.keyPath}
        countDownTimer={props.countDownTimer}
      />
      <Draggable draggableId={props.id} index={props.index}>
        {(provided) => (
          <CountDownTimerContainer
            ref={provided.innerRef}
            draggableProps={provided.draggableProps}
          >
            <DraggableOverlay>
              <Editable
                onEdit={toggleConfig}
                onCopy={() => duplicate(props.id)}
                handleProps={provided.dragHandleProps}
              >
                <>{props.children}</>
              </Editable>
            </DraggableOverlay>
          </CountDownTimerContainer>
        )}
      </Draggable>
    </>
  )
}

export const CountDownTimerContainer = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactElement
    draggableProps?: DraggableProvidedDraggableProps
  }
>((props, ref) => {
  return (
    <StyledGrid item xs={12} ref={ref} {...props.draggableProps}>
      {props.children}
    </StyledGrid>
  )
})

const StyledGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
`
